import type { ReactNode } from 'react';
import { Contrast } from 'lucide-react';
import type { JobMobileState } from './use-job-mobile';
import type { PaigePageMode } from './mobile-types';

/** The three choices, in the contract's order, each with its one word. */
export const pageModes: readonly { value: PaigePageMode; label: string; word: string }[] = [
  { value: 'greyscale', label: 'Greyscale', word: 'Recommended' },
  { value: 'bw', label: 'Black and white', word: 'Smallest' },
  { value: 'colour', label: 'Colour', word: 'Largest' },
];

/**
 * Scan from a phone › Options › Page colour (docs/engineering/mobile-capture.md, 7): how Paige Mobile
 * prepares this job's pages before it sends them. The setup map's segmented control, saved at once.
 */
export function MobilePageMode({ state }: { state: JobMobileState }): ReactNode {
  const current = state.mobile?.pageMode ?? 'greyscale';
  const runsJobs = window.paigeWorkbench?.runsJobs !== false;
  return (
    <div className="paige-email-sheet-switch paige-phone-option">
      <span className="paige-email-sheet-row-icon" aria-hidden="true">
        <Contrast size={20} />
      </span>
      <span>
        <strong>Page colour</strong>
        <small>{pageModes.find((mode) => mode.value === current)?.word}</small>
      </span>
      <span className="paige-retention-choices" role="radiogroup" aria-label="Page colour">
        {pageModes.map((mode) => (
          <button
            type="button"
            key={mode.value}
            role="radio"
            aria-checked={mode.value === current}
            className={`paige-retention-choice${mode.value === current ? ' selected' : ''}`}
            disabled={state.saving || !runsJobs}
            onClick={() => void state.save({ pageMode: mode.value })}
          >
            {mode.label}
          </button>
        ))}
      </span>
    </div>
  );
}
